import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import {Box, Button, Divider, IconButton, Stack, TextField, Typography} from "@mui/material";
import CustomTextInput from "../../components/CustomTextInput";
import CloseIcon from "@mui/icons-material/Close";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import React, {useEffect, useRef} from "react";
import SingleDatePicker from "../../components/form/SingleDatePicker";
import dayjs from "dayjs";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '500px',
    bgcolor: 'background.paper',
    borderRadius: '15px',
    boxShadow: 24,
};

const emptyDefaults = {
    id: '',
    uuid: '',
    issue_date: '',
};

export default function PrecedingInvoiceDetailsModal({
                                                   open,
                                                   onClose,
                                                   readOnly = false,
                                                   initialValue,
                                                   addPrecedingInvoiceDetails
                                               }) {
    const mergedInitial = {
        ...emptyDefaults,
        ...(initialValue || {}),
    };

    const initialValueRef = useRef(mergedInitial);
    initialValueRef.current = mergedInitial;

    const {
        handleSubmit: handlePopupSubmit,
        control: popupControl,
        reset: resetPopupForm,
        formState: {errors: popupErrors},
    } = useForm({
        defaultValues: mergedInitial,
    });

    useEffect(() => {
        if (!open) return;
        resetPopupForm({
            ...emptyDefaults,
            ...(initialValueRef.current || {}),
        });
    }, [open, resetPopupForm]);

    const handleFormSubmit = (data) => {
        const precedingInvoiceData = [{
            id: data?.id,
            uuid: data?.uuid,
            issue_date: data?.issue_date
                ? dayjs(data?.issue_date).format("YYYY-MM-DD")
                : null,
        }];
        Object.keys(precedingInvoiceData).forEach((key) => {
            if (!precedingInvoiceData[key]) {
                delete precedingInvoiceData[key];
            }
        });
        addPrecedingInvoiceDetails?.(precedingInvoiceData);
        onClose();
    };

    return (
        <Modal
            open={open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose();
                }
            }}
            className={'backdrop-model'}
        >
            <Fade in={open}>
                <Box sx={style}>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            px: 2,
                            py: 2,
                            borderBottom: '1px solid #e0e0e0',
                        }}
                    >
                        <Typography variant="h6">Preceding Invoice Details</Typography>
                        <IconButton onClick={onClose}>
                            <CloseIcon/>
                        </IconButton>
                    </Box>
                    <Divider/>
                    <Box sx={{p: 2}}>
                        <Stack spacing={2}>
                            <CustomTextInput
                                name="id"
                                label="Invoice Number"
                                control={popupControl}
                                errors={popupErrors}
                                readOnly={readOnly}
                            />
                            <CustomTextInput
                                name={'uuid'}
                                label={'Invoice UUID'}
                                control={popupControl}
                                errors={popupErrors}
                                readOnly={readOnly}
                            />
                            <SingleDatePicker
                                name={'issue_date'}
                                label={'Invoice Date'}
                                control={popupControl}
                                errors={popupErrors}
                                readOnly={readOnly}
                            />
                        </Stack>
                    </Box>
                    <Divider/>
                    <Box
                        sx={{
                            px: 2,
                            py: 1,
                            borderTop: '1px solid #e0e0e0',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: 1,
                        }}
                    >
                        <Button
                            id="add-details"
                            type="button"
                            variant="contained"
                            color="primary"
                            onClick={
                                readOnly
                                    ? onClose
                                    : handlePopupSubmit(handleFormSubmit)
                            }
                        >
                            {readOnly ? "Done" : "Add"}
                        </Button>
                    </Box>
                </Box>
            </Fade>
        </Modal>
    );
}